var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"summary-stores-ranking\" class=\"summary-charts summary-charts-ranking\"></div>\n<div style=\"\n        text-align: left;\n        min-width: 100%;\n        padding: 0 20px;\n        top: -20px;\n        position: relative;\n        display: block;\n        font-size: 12px;\">* "
    + container.escapeExpression(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Message.SummaryValuesReferCurrentMonth",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":9,"column":28},"end":{"line":9,"column":77}}}))
    + " </div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/summary-stores-ranking-after-sales.hbs
// module id = ylIj
// module chunks = 1